export interface SmsTemplateForm {
  name: string;
  text: string;
}

export const EMPTY_SMS_TEMPLATE_FORM: SmsTemplateForm = { name: '', text: '' };

export interface SmsVariable {
  key: string;
  label: string;
  source: string;
  example: string;
}

export const SMS_VARIABLES: SmsVariable[] = [
  { key: '{lead_name}',      label: 'Имя лида',              source: 'tasks.title',         example: 'Кудрявцев Вячеслав' },
  { key: '{lead_phone}',     label: 'Телефон лида',          source: 'tasks.phone',         example: '+7 (960) 272-99-19' },
  { key: '{executor_name}',  label: 'Имя исполнителя',       source: 'userId → name',       example: 'СО Анна Пуженкова' },
  { key: '{executor_phone}', label: 'Телефон исполнителя',   source: 'userId → work_phone', example: '79001234567' },
  { key: '{city}',           label: 'Город отправки',        source: 'tasks.city',          example: 'г Санкт-Петербург' },
  { key: '{destination}',    label: 'Город назначения',      source: 'tasks.destination',   example: 'г Чита' },
  { key: '{sending_date}',   label: 'Дата отправки',         source: 'tasks.sending',       example: '16.06.2026' },
  { key: '{arrival_date}',   label: 'Дата прибытия',         source: 'tasks.arrival',       example: '17.06.2026' },
  { key: '{stage_name}',     label: 'Этап',                  source: 'boardId → name',      example: 'Анкета' },
  { key: '{source}',         label: 'Источник',              source: 'tasks.source',        example: 'КонстантинОникс' },
  { key: '{note}',           label: 'Примечание',            source: 'tasks.note',          example: 'Примечание' },
  { key: '{date}',           label: 'Текущая дата',          source: 'текущая дата',        example: '23.06.2026' },
];

export const applyPreview = (text: string): string =>
  SMS_VARIABLES.reduce((t, v) => t.replaceAll(v.key, v.example), text);
